import { useQuery, useMutation } from "@tanstack/react-query";
import { GET, POST, DELETE, PUT } from "../../../../services/index";
import { message } from "antd";

export const useFetchUser = (companyId) => {
  return useQuery(
    ["getFetchUser"],
    async () => {
      console.log("companyId",companyId);
      try {
        const endpoint = `/api/v1/users/list/${companyId}`;
        const { result } = await GET(endpoint);
        return result;
      } catch (error) {
        await message.destroy();
        message.error("Failed To Load User..");
      }
    }
  );
};

export const UseFetchCreateUser = () => {
  return useMutation(async (payload) => {
    try {
      const endPoint = `/api/v1/Users`;
      const result = POST(endPoint, payload);
      return result;
    } catch (error) {
      await message.destroy();
      message.error("Failed To Create User..");
    }
  });
};

export const UseFetchUpdateUser = () => {
  return useMutation(async (payload) => {
    try {
      const endPoint = `/api/v1/Users`;
      const result = PUT(endPoint, payload);
      return result;
    } catch (error) {
      await message.destroy();
      message.error("Failed To Update User..");
    }
  });
};

export const UseFetchDeleteUser = () => {
  return useMutation(async (id) => {
    try {
      const endPoint = `/api/v1/Users/${id}`;
      const result = await DELETE(endPoint);
      return result;
    } catch (error) {
      await message.destroy();
      message.error("Failed To Delete User..");
    }
  });
};

// --- พนักงานข้ามบริษัท ---
// บัญชีเดียวทำงานได้หลายบริษัท: "เพิ่ม" = ผูกเข้าบริษัทนี้ ไม่ใช่สร้างบัญชีใหม่
// จึงใช้ทุกอย่างเหมือนเดิม (ชื่อ/รหัส/กะ/หน้าที่) และแก้ที่เดียวมีผลทุกบริษัท

export const useFetchTransferableUsers = (enabled = false) => {
  return useQuery(
    ["transferableUsers", sessionStorage.getItem("activeCompanyId")],
    async () => {
      // ห้าม catch แล้วคืน [] — จะทำให้ "โหลดพัง" กับ "ไม่มีข้อมูล" หน้าตาเหมือนกัน
      // แล้วไล่หาสาเหตุไม่ได้เลย ปล่อยให้ reject เพื่อให้หน้าจอโชว์ error จริง
      const { result } = await GET(`/api/v1/users/transferable`);
      return result || [];
    },
    { enabled, staleTime: 60 * 1000, retry: 0 }
  );
};

// ⚠️ ต้องส่ง body ต่อไปให้ครบ — เดิมรับแค่ { id } แล้วยิง {} ทิ้ง
// กะ/หน้าที่ที่ admin กรอกในฟอร์มไปเลย backend จึงได้ req.body ว่างทุกครั้ง
// แล้ว mysql2 แปลง undefined เป็น NULL เงียบ ๆ (ไม่ error) → ได้พนักงานที่
// JobType/Shift เป็น NULL ซึ่งระบบจ่ายเคสมองไม่เห็นตลอดไป
export const useAddUserToCompany = () =>
  useMutation(async ({ id, ...body }) => await POST(`/api/v1/users/${id}/companies`, body));

export const useRemoveUserFromCompany = () =>
  useMutation(async ({ id }) => await DELETE(`/api/v1/users/${id}/companies`));
